import { Control } from "react-hook-form";
import styled from "@emotion/styled";

import { Flex } from "../../../styles/utility-components";
import { BidFilters } from "../utils";
import AssigneeFilterContent from "./Assignee";
import AwardDateFilterContent from "./AwardDate";
import BuyersFilterContent from "./Buyers";
import CreatedByFilterContent from "./CreatedBy";
import CreatedDateFilterContent from "./CreatedDate";
import LastUpdatedDateFilterContent from "./LastUpdatedDate";
import StageFilterContent from "./Stage";
import SubmissionDateFilterContent from "./SubmissionDate";
import SuppliersFilterContent from "./Suppliers";
import TeamFilterContent from "./Team";
import ValueFilterContent from "./Value";

export interface BidFilterContentProps {
  control: Control<BidFilters, unknown>;
  data?: BidFilters;
}

export const StyledFilterContent = styled(Flex)({
  flexDirection: "column",
  gap: 16,
  padding: "24px",
  paddingTop: "2px",
});

export const bidFilterContents = {
  assignedTo: AssigneeFilterContent,
  createdBy: CreatedByFilterContent,
  team: TeamFilterContent,
  stage: StageFilterContent,
  createdDate: CreatedDateFilterContent,
  submissionDate: SubmissionDateFilterContent,
  awardDate: AwardDateFilterContent,
  value: ValueFilterContent,
  lastUpdated: LastUpdatedDateFilterContent,
  buyers: BuyersFilterContent,
  suppliers: SuppliersFilterContent,
};
